import React from 'react'


export default function Footer() {

    return (
        <footer className="d-flex flex-wrap pt-1 border-top container-fluid footer bg-white">
            <div className="container align-items-center justify-content-center">
                <div className="row">
                <div className="col-md-6 d-flex justify-content-sm-start justify-content-center align-middle pt-2 text-center order-lg-0 order-1">
                    <p className="text-muted">2021 ©<a href="https://liberhash.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none" style={{color: '#ffa900'}} >
                        liberhash.</a></p>
                </div>
                <div className="col-md-6 d-flex justify-content-sm-end justify-content-center p-0 order-lg-1 order-0">
                    <ul className="d-flex mb-0">
                    <li className="px-1 py-2 text-muted"><a href="https://liberhash.com/faq.html" target="_blank" rel="noopener noreferrer" className="text-decoration-none link-footer" style={{color: '#ffa900'}}>Ayuda </a> | </li>
                    <li className=" py-2 text-muted"><a href="https://liberhash.com/assets/politicas/LIBERHASH%20-%20Terminos%20y%20Condiciones%20.pdf" className="text-decoration-none link-footer" style={{color: '#ffa900'}} target="_blank" rel="noopener noreferrer"> Términos y
                        condiciones</a></li>
                    </ul>
                </div>
                </div>
            </div>
        </footer>   
    )
}
